import React from 'react';
import { trans, getPagePath } from '@spotahome/bff/client';
import { CookiesBanner as CookiesBannerComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/CookiesBanner.css';

const CookiesBanner = () => (
  <CookiesBannerComponent
    message={trans('landingpage.label.cookies_improve_experience')}
    linkText={trans('landingpage.label.cookies_learn_more')}
    link={getPagePath('externals.landing-pages.cookies-policy')}
  />
);

export default CookiesBanner;
